import { router } from '@inertiajs/vue3';

const GTM_CONTAINER_ID = 'GTM-WTSZZ522';
const CONSENT_COOKIE = 'cookie_consent';
const CONSENT_MAX_AGE = 60 * 60 * 24 * 182; // 6 months (CNIL recommendation)
const SIGNUP_PENDING_KEY = 'gtm_signup_pending';

let initialized = false;

export function analyticsId() {
  return document.querySelector('meta[name="google-analytics-id"]')?.content;
}

// 'accepted', 'refused' or null when the user has not chosen yet
export function getConsent() {
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${CONSENT_COOKIE}=(accepted|refused)`),
  );
  return match ? match[1] : null;
}

export function setConsent(value) {
  document.cookie = `${CONSENT_COOKIE}=${value}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`;
}

// The sign_up flag is rendered once by the server (session-based), but the
// user may not have consented yet on that page load. Queue it and let
// initAnalytics flush it once analytics are allowed to run.
export function queueSignupEvent() {
  if (document.querySelector('meta[name="gtm-signup-event"]')) {
    localStorage.setItem(SIGNUP_PENDING_KEY, '1');
  }
}

export function trackPageView() {
  if (!window.gtag) return;

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
    page_title: document.title,
  });
}

// Loads gtag.js + the GTM container and starts tracking page views on every
// Inertia navigation. Must only be called once consent has been given.
export function initAnalytics() {
  const gaId = analyticsId();
  if (!gaId || initialized) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Consent Mode v2: only analytics, no advertising cookies
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'granted',
  });
  window.gtag('js', new Date());
  // Page views are sent on Inertia 'navigate' (fires on first load too),
  // so disable the automatic one to avoid double-counting.
  window.gtag('config', gaId, { send_page_view: false });

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(gtagScript);

  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(gtmScript);

  router.on('navigate', () => {
    trackPageView();
  });

  if (localStorage.getItem(SIGNUP_PENDING_KEY)) {
    window.gtag('event', 'sign_up_event');
    localStorage.removeItem(SIGNUP_PENDING_KEY);
  }
}
